import { useRef, useState } from 'react'

function useFilterSearchPagination({ initialFilterData, initialPagination }) {
	const initialFilterDataRef = useRef(initialFilterData)
	const [filterData, setFilterData] = useState(initialFilterData)
	const [appliedFilterData, setAppliedFilterData] = useState(initialFilterData)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [pagination, setPagination] = useState(initialPagination)

	function patchFilterData(patch) {
		setFilterData(prev => ({ ...prev, ...patch }))
	}

	function applySearch(search, executeSearch) {
		const nextFilterData = { ...filterData, search, page: null }
		setFilterData(nextFilterData)
		if (typeof executeSearch === 'function') {
			executeSearch(nextFilterData)
		}
	}

	function applyFilters(executeSearch) {
		const nextFilterData = { ...filterData, page: null }
		setFilterData(nextFilterData)
		if (typeof executeSearch === 'function') {
			executeSearch(nextFilterData)
		}
	}

	function paginate(page) {
		setFilterData(prev => ({ ...prev, page }))
	}

	function resetFilters(resetFilterData, executeSearch) {
		setFilterData(resetFilterData)
		setAppliedFilterData(resetFilterData)
		setFilterDataExist(false)
		if (typeof executeSearch === 'function') {
			executeSearch(resetFilterData)
		}
	}

	function resetToInitialFilters(executeSearch) {
		const resetFilterData = { ...initialFilterDataRef.current }
		resetFilters(resetFilterData, executeSearch)
	}

	return {
		filterData,
		setFilterData,
		appliedFilterData,
		setAppliedFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		patchFilterData,
		applySearch,
		applyFilters,
		paginate,
		resetFilters,
		resetToInitialFilters,
		initialFilterData: initialFilterDataRef.current,
	}
}

export default useFilterSearchPagination
